export default "__VITE_ASSET__BK3n1AMA__"